var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.25H11.25",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.25H16.25",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 17.5C25.625 22.214 25.625 24.5711 24.069 26.0355C22.513 27.5 20.0087 27.5 15 27.5H14.0341C9.95758 27.5 7.91933 27.5 6.50384 26.5027C6.09827 26.217 5.73823 25.8781 5.43463 25.4964C4.375 24.1642 4.375 22.2458 4.375 18.4091V15.2273C4.375 11.5233 4.375 9.67133 4.96117 8.19219C5.90352 5.81428 7.89642 3.93861 10.423 3.05169C11.9945 2.5 13.9623 2.5 17.8977 2.5C20.1466 2.5 21.271 2.5 22.169 2.81525C23.6128 3.32206 24.7516 4.39387 25.29 5.75268C25.625 6.5979 25.625 7.65618 25.625 9.77273V17.5Z",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 15C4.375 12.6988 6.24048 10.8333 8.54167 10.8333C9.3739 10.8333 10.355 10.9792 11.1642 10.7623C11.8831 10.5697 12.4447 10.0081 12.6373 9.28921C12.8542 8.48005 12.7083 7.4989 12.7083 6.66667C12.7083 4.36548 14.5738 2.5 16.875 2.5",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.7ba05e924ee02017525e0ec20058117c.svg";
export { ForwardRef as ReactComponent };